import { message } from 'ant-design-vue/es'

let lessNodesAppended
let currentColor

const updateTheme = primaryColor => {
  if (!primaryColor) return;
  currentColor = primaryColor
  
  const hideMessage = message.loading('加载主题...', 0)
  function buildIt () {
    if (!window.less || typeof window.less.modifyVars !== 'function') {
      hideMessage()
      return
    }
    setTimeout(() => {
      window.less
        .modifyVars({
          '@primary-color': currentColor
        })
        .then(() => {
          hideMessage()
        })
        .catch((e) => {
          message.error('Failed to update theme')
          hideMessage()
        })
    }, 200)
  }
  if (!lessNodesAppended) {
    // insert less.js and color.less
    const lessStyleNode = document.createElement('link')
    const lessConfigNode = document.createElement('script')
    const lessScriptNode = document.createElement('script')
    lessStyleNode.setAttribute('rel', 'stylesheet/less')
    lessStyleNode.setAttribute('href', 'static/less/Color.less')
    lessConfigNode.innerHTML = `
      window.less = {
        async: true,
        env: 'production',
        javascriptEnabled: true
      }
    `
    lessScriptNode.src = 'static/less.min.js'
    lessScriptNode.async = true
    lessScriptNode.onload = () => {
      buildIt()
      lessScriptNode.onload = null
    }
    lessScriptNode.onerror = () => {
      hideMessage()
      message.error('主题资源加载失败，请重新选择主题色')
      lessStyleNode.remove()
      lessConfigNode.remove()
      lessScriptNode.remove()
      lessNodesAppended = false
    }
    document.body.appendChild(lessStyleNode)
    document.body.appendChild(lessConfigNode)
    document.body.appendChild(lessScriptNode)
    lessNodesAppended = true
  } else buildIt();
  
}
export { updateTheme }
